// frontend/src/utils/slug.js
//
// Turns a database-provided button label ("Book Site Visit") into a
// hash-safe anchor id ("booksitevisit") — lowercase, alphanumeric only,
// no spaces or punctuation. Used to make each DB-driven CTA button a real,
// bookmarkable/shareable anchor: yourproject.com/#booksitevisit scrolls
// straight to wherever that button lives on the page, no matter what the
// admin panel currently has its label set to.
export function slugify(text = "") {
  return text
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "");
}

/**
 * Returns a unique slug for `label`, appending "-2", "-3", ... when the
 * same label (e.g. "Get More Details") repeats across multiple items in a
 * list — plain HTML ids must be unique on the page, so the first item
 * keeps the clean slug and later duplicates get a suffix.
 */
export function uniqueSlug(label, usedSlugs) {
  const base = slugify(label) || "section";
  let candidate = base;
  let n = 2;
  while (usedSlugs.has(candidate)) {
    candidate = `${base}-${n}`;
    n += 1;
  }
  usedSlugs.add(candidate);
  return candidate;
}
